<template>
  <div class="page-content--bgf7">
    <section class="au-breadcrumb2">
      <div class="container m-b-60">
        <v-card class="pa-5">
          <div
            v-if="!editMode"
            class="row"
          >
            <div class="col-md-12">
              <p class="text-h5">
                Import to my Video Library from:
              </p>
              <v-radio-group
                v-model="parser"
                row
                class="import-types"
              >
                <v-radio value="mrss">
                  <template v-slot:label>
                    <v-card
                      v-ripple
                      flat
                      width="200"
                      style="border: 1px solid #eee;"
                    >
                      <v-card-text
                        class="text-center"
                        :class="{'blue lighten-4': parser === 'mrss'}"
                      >
                        <v-icon
                          large
                          color="orange darken-2"
                        >
                          mdi-rss
                        </v-icon>
                        <div class="m-t-10 text-body-1">
                          mRSS
                        </div>
                      </v-card-text>
                    </v-card>
                  </template>
                </v-radio>
                <v-radio
                  value="ftp"
                >
                  <template v-slot:label>
                    <v-card
                      flat
                      width="200"
                      style="border: 1px solid #eee;"
                    >
                      <v-card-text
                        class="text-center pl-0 pr-0"
                        :class="{'blue lighten-4': parser === 'ftp'}"
                      >
                        <v-icon
                          large
                          color="primary darken-2"
                        >
                          mdi-folder-upload
                        </v-icon>
                        <div class="m-t-10 text-body-1">
                          FTP / Watch Folder
                        </div>
                      </v-card-text>
                    </v-card>
                  </template>
                </v-radio>
                <v-radio
                  value="aws"
                  disabled
                >
                  <template v-slot:label>
                    <v-card
                      flat
                      width="200"
                      style="border: 1px solid #eee; background-color: #f1f1f1;"
                    >
                      <v-card-text class="text-center">
                        <v-icon
                          large
                          color="red darken-2"
                        >
                          mdi-aws
                        </v-icon>
                        <div class="m-t-10 text-body-1">
                          AWS / Watch Folder
                        </div>
                      </v-card-text>
                    </v-card>
                  </template>
                </v-radio>
              </v-radio-group>
              <p
                v-if="parser === 'mrss'"
                class="grey--text text--darken-3"
              >
                Import a MRSS feed. The feed is updated and synced with Noisypeak
                Playout on an ongoing basis and will auto add new videos to your video library.
              </p>
            </div>
          </div>
          <div
            v-if="parser === 'mrss'"
            class="row"
          >
            <div class="col-md-12 m-b-0 p-b-0">
              <v-text-field
                v-model="mrssURL"
                prepend-icon="fas fa-link"
                :disabled="editMode"
                label="MRSS URL"
                placeholder="http://"
                outlined
                dense
              />
            </div>
            <div class="col-md-12 p-t-0 m-t-0 text-right">
              <v-btn
                depressed
                :loading="processing"
                :color="isMRSSURLValid ? 'primary': ''"
                @click="parseMRSS()"
              >
                <v-icon left>
                  mdi-import
                </v-icon> Parse
              </v-btn>
            </div>
          </div>
          <div
            v-if="parser === 'ftp'"
            class="row"
          >
            <div class="col-md-12">
              <base-card>
                <v-card-title>Name</v-card-title>
                <v-card-text>
                  <v-text-field
                    v-model="ftpInput.name"
                    outlined
                    dense
                    label="Name*"
                    :counter="512"
                    :rules="rules.nameRules"
                  />
                </v-card-text>
              </base-card>
              <base-card>
                <v-card-title>FTP URL</v-card-title>
                <v-card-text>
                  <v-text-field
                    v-model="ftpInput.url.url"
                    prepend-icon="mdi-folder-network"
                    hide-details
                    outlined
                    dense
                    label="URL*"
                    :counter="1024"
                    :placeholder="ftpInput.url.selectedType + '://host/path'"
                    :error="ftpInput.url.url !== '' && !ftpInput.url.hostPath"
                    @change="onInputURLChange"
                  />
                </v-card-text>
              </base-card>
              <base-card>
                <v-card-title>Details</v-card-title>
                <v-card-text>
                  <div class="row">
                    <div class="col-md-6">
                      <v-text-field
                        v-model="ftpInput.url.login"
                        hide-details
                        label="Login"
                        @change="buildInputURL()"
                      />
                    </div>
                    <div class="col-md-6">
                      <v-text-field
                        v-model="ftpInput.url.password"
                        hide-details
                        label="Password"
                        @change="buildInputURL()"
                      />
                    </div>
                    <div class="col-md-10">
                      <v-text-field
                        v-model="ftpInput.url.hostPath"
                        hide-details
                        label="Host/Path"
                        @change="buildInputURL()"
                      />
                    </div>
                    <div class="col-md-2">
                      <v-checkbox
                        v-model="ftpInput.url.secure"
                        hide-details
                        @change="buildInputURL()"
                      >
                        <template v-slot:label>
                          <div>
                            Secure
                          </div>
                        </template>
                      </v-checkbox>
                    </div>
                  </div>
                </v-card-text>
              </base-card>
              <base-card>
                <v-card-title>Tags</v-card-title>
                <v-card-text>
                  <v-combobox
                    v-model="ftpInput.tags"
                    outlined
                    dense
                    :items="tags"
                    item-text="name"
                    return-object
                    :search-input.sync="tagSearch"
                    hide-selected
                    label="Tags"
                    multiple
                    persistent-hint
                    small-chips
                    clearable
                  >
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>
                            No results matching
                            "<strong>{{ tagSearch }}</strong>".
                            Press <kbd>enter</kbd> to create a new one
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-combobox>
                </v-card-text>
              </base-card>
              <base-card>
                <v-card-title>Watch Folder</v-card-title>
                <v-card-text>
                  <v-switch
                    v-model="ftpInput.watchfolder"
                    dense
                    color="success"
                    inset
                  >
                    <template v-slot:label>
                      <v-list-item v-ripple>
                        <v-list-item-content>
                          <v-list-item-title>Enable watch folder</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-switch>
                </v-card-text>
                <v-card-actions class="m-r-0">
                  <v-spacer />
                  <v-btn
                    :disabled="!isFTPFormValid"
                    :color="isFTPFormValid ? 'success': ''"
                    @click="saveFTP()"
                  >
                    <v-icon left>
                      mdi-content-save
                    </v-icon> Save
                  </v-btn>
                </v-card-actions>
              </base-card>
            </div>
          </div>
        </v-card>
        <v-card
          v-if="showResult"
          class="pa-5 m-t-20"
        >
          <div class="row">
            <div class="col-md-12 p-t-0">
              <p class="text-h5">
                Parse result
              </p>
              <table class="table table-bordered green lighten-5 import-table">
                <tr>
                  <td
                    style="width: 100px;"
                    class="text-center p-t-10"
                  >
                    <v-icon
                      color="#3076c2"
                      x-large
                    >
                      mdi-xml
                    </v-icon>
                  </td>
                  <td class="p-t-10 p-b-10 p-l-10">
                    <strong>Channel title:</strong> {{ importResult.name || 'N/A' }}<br>
                    <strong>Entries available:</strong> {{ newImport.itemCount }}
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 p-t-20">
              <v-text-field
                v-model="newImport.name"
                label="Import name*"
                outlined
                counter
                dense
              />
              <v-combobox
                v-model="newImport.tags"
                outlined
                dense
                :items="tags"
                item-text="name"
                return-object
                :search-input.sync="tagSearch"
                hide-selected
                label="Tags"
                multiple
                persistent-hint
                small-chips
                clearable
              >
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        No results matching
                        "<strong>{{ tagSearch }}</strong>".
                        Press <kbd>enter</kbd> to create a new one
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-combobox>
              <v-text-field
                v-model="newImport.retentionPeriod"
                style="width: 200px;"
                dense
                :rules="rules.retentionPeriodRules"
                suffix="days"
                label="File-expiration interval"
              />
            </div>
            <div class="col-md-12 text-right">
              <v-btn
                depressed
                :loading="processing"
                :color="isFormValid ? 'success': ''"
                @click="saveImport()"
              >
                <v-icon left>
                  fas fa-save
                </v-icon>
                <span v-if="editMode">Save</span>
                <span v-else>Add Source</span>
              </v-btn>
            </div>
          </div>
        </v-card>
      </div>
    </section>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { processMediaSource, processTag } from '@/store/converters'
  import { urlObject, buildURL, processURLInfo } from '@/helpers/url'

  export default {
    data () {
      return {
        channel: {},
        editMode: false,
        mediaSource: {},
        processing: false,
        parser: 'mrss',
        mrssURL: '',
        activeRow: -1,
        importResult: {
          exampleItems: [],
        },
        exampleItem: 0,
        showResult: false,
        tags: [],
        tagSearch: null,
        newImport: {
          url: '',
          name: '',
          tags: [],
          retentionPeriod: 30,
        },
        ftpInput: {
          name: '',
          url: {}, // urlObject
          watchfolder: false,
          tags: [],
        },
        rules: {
          nameRules: [
            (v) => !!v || 'Name is required',
            (v) => (v && v.length <= 512) || 'Name must be less than 512 characters',
          ],
          retentionPeriodRules: [
            (v) => (v >= 1 && v <= 365) || 'Interval should be between 1 and 365 days',
          ],
        },
      }
    },
    computed: {
      loading () {
        return this.$store.getters.isDataLoaded
      },
      isMRSSURLValid () {
        return this.mrssURL.startsWith('http')
      },
      isFormValid () {
        if (!(this.newImport.name.length >= 1 && this.newImport.name.length <= 512)) {
          return false
        }
        return true
      },
      isFTPFormValid () {
        if (!(this.ftpInput.name.length >= 1 && this.ftpInput.name.length <= 500)) {
          return false
        }
        if (!['ftp', 'ftps'].includes(this.ftpInput.url.type) && this.ftpInput.url.hostPath === '') {
          return false
        }
        return true
      },
    },
    created () {
      this.ftpInput.url = Vue.util.extend({}, urlObject)
      this.channel.id = this.$route.params.id
      if (this.$route.params.source_id && this.$route.params.source_id !== 'new') {
        this.editMode = true
        this.loadSource(this.$route.params.source_id)
      }
      this.getTags()
    },
    methods: {
      getTags () {
        const tagArgs = {
          'channel.id[eq]': this.channel.id,
          'auto[eq]': 1,
        }
        const tagReq = this.$store.dispatch('tags', tagArgs)

        return Promise.all([tagReq])
          .then((res) => {
            const tags = res[0]
            this.tags = tags.map((t) => processTag(t))
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
            this.$router.push({
              name: 'MediaSourcesPage',
            })
          })
          .finally(() => this.$store.commit('resolvePageLoader'))
      },
      loadSource (id) {
        this.parser = ''

        this.$store.commit('setPageLoader')

        const args = {
          $expand: 'tags',
          'id[eq]': id,
        }

        const mediaSourcesReq = this.$store.dispatch('mediaSources', args)

        return Promise.all([mediaSourcesReq])
          .then((res) => {
            const mediaSources = res[0]
            if (mediaSources.length === 0) {
              this.$router.push({
                name: 'MediaSourcesPage',
              })
              return
            }
            this.mediaSource = processMediaSource(mediaSources[0])

            if (this.mediaSource.type === 'mrss2') {
              this.mrssURL = this.mediaSource.url
              this.parser = 'mrss'
              this.parseMRSS()
            }
            if (this.mediaSource.type === 'ftp') {
              this.ftpInput.url.url = this.mediaSource.url
              this.ftpInput.tags = this.mediaSource.tags
              this.ftpInput.name = this.mediaSource.name
              this.parser = 'ftp'
              this.onInputURLChange()
            }
            if (this.mediaSource.type === 'ftp-watchfolder') {
              this.ftpInput.url.url = this.mediaSource.url
              this.ftpInput.tags = this.mediaSource.tags
              this.ftpInput.name = this.mediaSource.name
              this.ftpInput.watchfolder = true
              this.parser = 'ftp'
              this.onInputURLChange()
            }
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
            this.$router.push({
              name: 'MediaSourcesPage',
            })
          })
          .finally(() => this.$store.commit('resolvePageLoader'))
      },
      next () {
        this.exampleItem = this.exampleItem + 1 === this.length
          ? 0
          : this.exampleItem + 1
      },
      prev () {
        this.exampleItem = this.exampleItem - 1 < 0
          ? this.length - 1
          : this.exampleItem - 1
      },
      parseMRSS () {
        if (!this.isMRSSURLValid) return
        this.$store.commit('setPageLoader')
        this.processing = true

        const args = {
          url: this.mrssURL,
        }
        const parseReq = this.$store.dispatch('parseMRSS', args)

        return Promise.all([parseReq])
          .then((res) => {
            if (res.length) {
              this.importResult = res[0]
              if (this.editMode) {
                this.newImport.name = this.mediaSource.name
                this.newImport.tags = this.mediaSource.tags
                this.newImport.url = this.mediaSource.url
                this.newImport.retentionPeriod = this.mediaSource.retentionPeriod
              } else {
                this.newImport.url = this.mrssURL
                this.newImport.name = this.importResult.name || ''
                this.newImport.tags = []
                if (this.newImport.name) {
                  this.newImport.tags.push({
                    name: this.newImport.name,
                  })
                }
              }
              this.newImport.itemCount = this.importResult.item_count || 0
              this.showResult = true
            }
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          // eslint-disable-next-line no-return-assign
          .finally(() => {
            this.processing = false
            this.$store.commit('resolvePageLoader')
          })
      },
      guessTags () {
        const elementMap = {}
        for (let i = 0; i < this.importResult.elements.length; i += 1) {
          elementMap[this.importResult.elements[i]] = 1
        }
        for (let i = 0; i < this.importResult.options.length; i += 1) {
          switch (this.importResult.options[i].key) {
            case 'asset_name':
              // eslint-disable-next-line no-prototype-builtins
              if (elementMap.hasOwnProperty('media:title')) {
                this.importResult.options[i].assigned = 'media:title'
              // eslint-disable-next-line no-prototype-builtins
              } else if (elementMap.hasOwnProperty('title')) {
                this.importResult.options[i].assigned = 'title'
              }
              break
            case 'asset_extid':
              // eslint-disable-next-line no-prototype-builtins
              if (elementMap.hasOwnProperty('guid')) {
                this.importResult.options[i].assigned = 'guid'
              }
              break
            case 'asset_description':
              // eslint-disable-next-line no-prototype-builtins
              if (elementMap.hasOwnProperty('description')) {
                this.importResult.options[i].assigned = 'description'
              }
              break
            case 'asset_source_url':
              // eslint-disable-next-line no-prototype-builtins
              if (elementMap.hasOwnProperty('media:content/attribute:url')) {
                this.importResult.options[i].assigned = 'media:content/attribute:url'
              // eslint-disable-next-line no-prototype-builtins
              } else if (elementMap.hasOwnProperty('link')) {
                this.importResult.options[i].assigned = 'link'
              }
              break
            case 'asset_category':
              // eslint-disable-next-line no-prototype-builtins
              if (elementMap.hasOwnProperty('media:category')) {
                this.importResult.options[i].assigned = 'media:category'
              // eslint-disable-next-line no-prototype-builtins
              } else if (elementMap.hasOwnProperty('category')) {
                this.importResult.options[i].assigned = 'category'
              }
              break
            case 'asset_poster_url':
              // eslint-disable-next-line no-prototype-builtins
              if (elementMap.hasOwnProperty('media:thumbnail/attribute:url')) {
                this.importResult.options[i].assigned = 'media:thumbnail/attribute:url'
              }
              break
            case 'publication_date':
              // eslint-disable-next-line no-prototype-builtins
              if (elementMap.hasOwnProperty('pubDate')) {
                this.importResult.options[i].assigned = 'pubDate'
              }
              break
            default:
              break
          }
        }
      },
      saveImport () {
        if (!this.isFormValid) return

        this.$store.commit('setPageLoader')

        const data = {
          name: this.newImport.name,
          category: 'automatic',
          type: 'mrss2',
          url: this.newImport.url,
          retention_period: Number(this.newImport.retentionPeriod),
          tags: [{
            name: this.newImport.name,
            auto: true,
            channel_id: Number(this.channel.id),
          }],
          mrss_mapping: {},
          channel_id: Number(this.channel.id),
        }

        const uniqueTag = {}
        uniqueTag[this.newImport.name] = true
        for (let i = 0; i < this.newImport.tags; i += 1) {
          const tag = this.newImport.tags[i]
          // eslint-disable-next-line no-prototype-builtins
          if (uniqueTag.hasOwnProperty(tag.name)) {
            // eslint-disable-next-line no-continue
            continue
          }
          uniqueTag[tag.name] = true
          data.tags.push(tag)
        }
        if (this.editMode) {
          data.id = this.mediaSource.id
        }

        const action = this.editMode ? 'updateMediaSource' : 'createMediaSource'

        this.$store.dispatch(action, data)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: this.editMode ? 'The source successfully updated' : 'The source successfully created',
              timeout: 3000,
              color: 'success',
            })
            if (!this.editMode) {
              this.$router.push({
                name: 'MediaSourcesPage',
              })
            } else {
              this.$router.push({
                name: 'AutoSourceDetailPage',
                params: {
                  source_id: this.mediaSource.id,
                },
              })
            }
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
              bottom: true,
            })
          })
          .finally(() => this.$store.commit('resolvePageLoader'))
      },
      buildInputURL () {
        this.ftpInput.url.url = buildURL(this.ftpInput.url)
        this.updateFTPInputTag()
      },
      onInputURLChange () {
        const newURLObj = processURLInfo(this.ftpInput.url, { ftp: true, sftp: true }, 'ftp')
        this.ftpInput.url = Vue.util.extend({}, newURLObj)
        this.ftpInput.type = 'ftp'
        this.updateFTPInputTag()
      },
      updateFTPInputTag () {
        let found = -1
        for (let i = 0; i < this.ftpInput.tags.length; i += 1) {
          if (this.ftpInput.tags[i].auto) {
            found = i
            break
          }
        }
        if (this.ftpInput.url.hostPath) {
          if (found !== -1) {
            this.ftpInput.tags[found].name = this.ftpInput.url.hostPath
          } else {
            this.ftpInput.tags.push({
              auto: true,
              name: this.ftpInput.url.hostPath,
              channel_id: Number(this.channel.id),
            })
          }
        }
      },
      processInputTags () {
        for (let i = 0; i < this.ftpInput.tags.length; i += 1) {
          const tag = this.ftpInput.tags[i]
          if (!tag.name) {
            this.ftpInput.tags[i] = {
              auto: false,
              name: tag,
              channel_id: Number(this.channel.id),
            }
          }
        }
      },
      saveFTP () {
        if (!this.isFTPFormValid) return

        this.$store.commit('setPageLoader')

        this.processInputTags()

        const data = {
          name: this.ftpInput.name,
          type: 'ftp',
          url: this.ftpInput.url.url,
          tags: this.ftpInput.tags,
          channel_id: Number(this.channel.id),
          category: 'manual',
        }
        if (this.ftpInput.watchfolder) {
          data.type = 'ftp-watchfolder'
          data.category = 'automatic'
        }

        let action = 'createMediaSource'
        if (this.editMode) {
          data.id = this.mediaSource.id
          action = 'updateMediaSource'
        }

        this.$store.dispatch(action, data)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: this.editMode ? 'The source successfully updated' : 'The source successfully created',
              timeout: 3000,
              color: 'success',
            })
            if (!this.editMode) {
              this.$router.push({
                name: 'MediaSourcesPage',
              })
            } else {
              this.$router.push({
                name: 'SourceDetailPage',
                params: {
                  source_id: this.mediaSource.id,
                },
              })
            }
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
              bottom: true,
            })
          })
          .finally(() => this.$store.commit('resolvePageLoader'))
      },
    },
  }
</script>

<style>
  .import-types .v-input--selection-controls__input {
    display: none !important;
  }
  .example-table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
  }
  .cell-breakWord {
    word-wrap: break-word;
  }
</style>
